export default "__VITE_ASSET__Ck84s1wB__"